import { BrowserRouter } from "react-router-dom";

import { ColorSchemeScript, MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import LogRocket from "logrocket";

import {
  LanguageContext,
  useLanguageContext,
} from "@/hooks/use-language-context";
import Pages from "./Routes";
import { villaTheme } from "./theme/theme";
import "@goldseam/ui/styles.css";

import "./global.css";
import "./i18n";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

if (import.meta.env.PROD) {
  LogRocket.init("avkaji/villabraou");
}

const LanguageGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useLanguageContext();
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

const App: React.FC = () => {
  return (
    <>
      <ColorSchemeScript defaultColorScheme="auto" />
      <MantineProvider theme={villaTheme} defaultColorScheme="auto">
        <Notifications position="top-right" />
        <LanguageGate>
          <BrowserRouter>
            <Pages />
          </BrowserRouter>
        </LanguageGate>
      </MantineProvider>
    </>
  );
};

export default App;
